import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, QueryList, ViewChildren } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-collaboration-school',
  templateUrl: './collaboration-school.component.html',
  styleUrls: ['./collaboration-school.component.scss']
})
export class CollaborationSchoolComponent implements OnInit {

 constructor(@Inject(PLATFORM_ID) private platformId: Object, private router : Router) { }

  ngOnInit(): void {
  }


    appsUrl = environment.CMS_APPS_URL;
    signUrl = environment.WEB_URL;
    searchText = '';
    activeColor = 'rgb(95, 84, 238)';
    inactiveColor = 'rgb(129, 142, 173)';

    searchPodcasts() {
      
    }

    activeIndex = 0;

    @ViewChildren('sectionRef') sectionRefs!: QueryList<ElementRef>;
  
    onIntersectionChange(isIntersecting: boolean, index: number) {
      if (isIntersecting) {
        this.activeIndex = index;
      }
    }

    viewTutorial(group, tutorial){
      if (isPlatformBrowser(this.platformId)) { 
        this.router.navigateByUrl('/en/collaboration-school/' + group.groupId + '/' + tutorial.type);
      }
     }

     scrollTo(id: string) {
      if (isPlatformBrowser(this.platformId)) { 
        const element = document.getElementById(id);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          const offset = window.innerHeight * 0.2;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
        }
      }
    }

    sections = [
      {
        "title": "Getting Started",
        "viewAllCount": 5,
        groupId : 5,
        "cards": [
          {
            "title": "Introduction to Team Collaboration",
            "duration": "50 Minutes",
            "description": "Learn the fundamentals of building a collaborative team environment.",
            "type": "Video",
            "tag": "#Collaboration",
            "image": "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Communication in Remote Teams",
            "duration": "40 Minutes",
            "description": "Discover strategies to improve communication within distributed teams.",
            "type": "Read",
            "tag": "#RemoteWork",
            "image": "https://images.unsplash.com/photo-1516387938699-a93567ec168e?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Building a Positive Work Culture",
            "duration": "45 Minutes",
            "type": "Video",
            "description": "Explore ways to cultivate an inclusive and positive work culture.",
            "tag": "#Culture",
            "image": "https://images.unsplash.com/photo-1544531585-9847b68c8c86?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Time Management Techniques",
            "duration": "30 Minutes",
            "type": "Video",
            "description": "Master proven techniques to manage your time effectively.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1434626881859-194d67b2b86f?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Understanding Roles and Responsibilities",
            "duration": "35 Minutes",
            "type": "Read",
            "description": "A guide to clearly defining roles and responsibilities in teams.",
            "tag": "#Management",
            "image": "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Assembling your video",
        "viewAllCount": 16,
        groupId : 6,
        "cards": [
          {
            "title": "Best Practices for Video Editing",
            "duration": "40 Minutes",
            "description": "Learn essential editing techniques to create impactful videos.",
            "type": "Video",
            "tag": "#VideoEditing",
            "image": "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Scriptwriting for Engaging Videos",
            "duration": "25 Minutes",
            "type": "Read",
            "description": "Craft scripts that captivate and connect with your audience.",
            "tag": "#ContentCreation",
            "image": "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Adding Graphics and Animations",
            "duration": "35 Minutes",
            "type": "Video",
            "description": "Enhance your videos with engaging graphics and animations.",
            "tag": "#Design",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Choosing the Right Background Music",
            "duration": "20 Minutes",
            "type": "Video",
            "description": "Understand how to select music that complements your video.",
            "tag": "#SoundDesign",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Lighting Tips for High-Quality Videos",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "A practical guide to achieve professional lighting for video production.",
            "tag": "#Lighting",
            "image": "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Task Management",
        "viewAllCount": 10,
        groupId : 6,
        "cards": [
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }, {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Team Collaboration",
        "viewAllCount": 7,
        groupId : 2,
        "cards": [
          {
            "title": "Building Trust in Teams",
            "duration": "30 Minutes",
            "type": "Video",
            "description": "Discover how to foster trust within your team for better collaboration.",
            "tag": "#Teamwork",
            "image": "https://images.unsplash.com/photo-1516251193007-45ef944ab0c6?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Conflict Resolution Techniques",
            "duration": "45 Minutes",
            "type": "Read",
            "description": "Learn practical strategies for resolving conflicts in teams.",
            "tag": "#ConflictResolution",
            "image": "https://images.unsplash.com/photo-1562577309-2592ab84b1d7?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Project Management",
        "viewAllCount": 12,
        groupId : 2,
        "cards": [
          {
            "title": "Agile Project Management Basics",
            "duration": "50 Minutes",
            "type": "Read",
            "description": "Learn how to apply agile principles to your project workflow.",
            "tag": "#Agile",
            "image": "https://images.unsplash.com/photo-1573497019736-26e571f5c796?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Risk Management in Projects",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Understand techniques to identify and mitigate project risks.",
            "tag": "#RiskManagement",
            "image": "https://images.unsplash.com/photo-1581092334430-d472318f4f7e?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Smarter Marketing and Sales",
        "viewAllCount": 8,
        groupId : 8,
        "cards": [
          {
            "title": "Content Marketing Strategies",
            "duration": "45 Minutes",
            "type": "Read",
            "description": "Discover effective content strategies to attract and engage customers.",
            "tag": "#Marketing",
            "image": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Sales Techniques That Work",
            "duration": "35 Minutes",
            "type": "Video",
            "description": "Learn proven sales techniques to close deals effectively.",
            "tag": "#Sales",
            "image": "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Simplified HR Management",
        "viewAllCount": 6,
        groupId : 8,
        "cards": [
          {
            "title": "Recruitment Best Practices",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Explore strategies to attract and recruit top talent.",
            "tag": "#HR",
            "image": "https://images.unsplash.com/photo-1521791055366-0d553872125f?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Employee Engagement Techniques",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Discover methods to increase employee engagement and satisfaction.",
            "tag": "#EmployeeEngagement",
            "image": "https://images.unsplash.com/photo-1557800636-894a64c1696f?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      },
      {
        "title": "Efficient Customer Support",
        "viewAllCount": 5,
        groupId : 9,
        "cards": [
          {
            "title": "Handling Customer Complaints",
            "duration": "35 Minutes",
            "type": "Video",
            "description": "Learn how to address and resolve customer complaints effectively.",
            "tag": "#CustomerService",
            "image": "https://images.unsplash.com/photo-1519241047957-be31d7379a5d?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Building Customer Loyalty",
            "duration": "40 Minutes",
            "type": "Read",
            "description": "Explore strategies to retain customers and build loyalty.",
            "tag": "#CustomerLoyalty",
            "image": "https://images.unsplash.com/photo-1531177072780-0a7256046923?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Effective Task Prioritization",
            "duration": "30 Minutes",
            "type": "Read",
            "description": "Learn how to prioritize tasks based on urgency and importance.",
            "tag": "#Productivity",
            "image": "https://images.unsplash.com/photo-1509474520651-2d5f1c45f5d0?auto=format&fit=crop&w=800&q=80"
          },
          {
            "title": "Project Planning Essentials",
            "duration": "40 Minutes",
            "type": "Video",
            "description": "Master project planning techniques to manage tasks efficiently.",
            "tag": "#Planning",
            "image": "https://images.unsplash.com/photo-1551503766-ac63dfa6401c?auto=format&fit=crop&w=800&q=80"
          }
        ]
      }
    ]    
    
    
  

  sideNavigation = [
    "Getting Started",
    "Assembling your video",
    "Task Management",
    "Team Collaboration",
    "Project Management",
    "Smarter Marketing and Sales",
    "Simplified HR Management",
    "Efficient Customer Support"
  ]
}
